export const environment = {
  production: false,
  environmentName: 'local',
  sentryDsn: 'https://516456f38111acd9f9ad963846a7eaee@o4511807647711232.ingest.us.sentry.io/4511807726485504',
  apiEndpoints: {
    // baseUrl: "https://api-dev.tenants.sanchiconnect.com/",
    baseUrl: "https://api.tenants.sanchidev.in/",
    // baseUrl: "http://localhost:3006/",
  },
  imageKitBaseUrl: 'https://ik.imagekit.io/3buq5bm7v/',
  mixPanelKey: 'b3a983a33841557e43c39221dd732b46',
  blogs: 'https://sanchiconnect.com/blog/wp-json/wp/v2/posts?_fields=author,id,title,link,excerpt,jetpack_featured_media_url',

  feture_supportingDocument: false

};
